import { render, staticRenderFns } from "./PurchaseComplete.vue?vue&type=template&id=63518ea6&scoped=true&"
import script from "./PurchaseComplete.vue?vue&type=script&lang=js&"
export * from "./PurchaseComplete.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseComplete.vue?vue&type=style&index=0&id=63518ea6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63518ea6",
  null
  
)

export default component.exports